import { render, staticRenderFns } from "./icon-zip.vue?vue&type=template&id=2e20484d&"
import script from "./icon-zip.vue?vue&type=script&lang=js&"
export * from "./icon-zip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports